module.exports = __webpack_public_path__ + "img/cutdownPriceDiaLogBgImg.fe9297e9.png";